import {Action} from '@ngrx/store';

export const TRASH_ACTION = '[TRASH] Catch error';

export class TrashAction implements Action {
    readonly type = TRASH_ACTION;
}

export type Actions = TrashAction;
